// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CommonContactForm-module-formField-XV3ZD{-webkit-margin-after:var(--des-dimension-gap-and-padding-general-away-default);margin-block-end:var(--des-dimension-gap-and-padding-general-away-default)}.CommonContactForm-module-disclaimer-2hwhU{-webkit-margin-before:var(--des-dimension-gap-and-padding-general-near-medium);margin-block-start:var(--des-dimension-gap-and-padding-general-near-medium)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formField": "CommonContactForm-module-formField-XV3ZD",
	"disclaimer": "CommonContactForm-module-disclaimer-2hwhU"
};
export default ___CSS_LOADER_EXPORT___;
